<template>
    <v-layout column align-start>
        <span v-if="!!text"> {{ text }} </span>
        <span v-if="!!desc"> {{ desc }} </span>
        <span v-if="!!coda"> {{ coda }} </span>
    </v-layout>
</template>

<script>
import { EXPO_MATCHING_DIRECTIONS, initExpoMatching } from "@/assets/variables";
export default {
    props: {
        item: { type: Object, default: initExpoMatching },
        isUserEmployee: { type: Boolean, default: false },
        isUserEmployer: { type: Boolean, default: false },
    },
    computed: {
        text() {
            switch (this.item.isGranted) {
                case null: {
                    switch (this.item.direction) {
                        case EXPO_MATCHING_DIRECTIONS.TO_EMPLOYEE.value: {
                            if (this.isUserEmployee) return "기업에서 면접 요청 중입니다.";
                            return "회원에게 면접 요청 중입니다.";
                        }
                        case EXPO_MATCHING_DIRECTIONS.TO_EMPLOYER.value: {
                            if (this.isUserEmployer) return "회원에게서 면접 요청이 있습니다.";
                            return "기업에 면접 요청 중입니다.";
                        }
                    }
                }
                case true: {
                    return "매칭이 완료되었습니다.";
                }
                case false: {
                    return "매칭이 실패하였습니다.";
                }
            }
        },
        desc() {
            switch (this.item.isGranted) {
                case null: {
                    switch (this.item.direction) {
                        case EXPO_MATCHING_DIRECTIONS.TO_EMPLOYEE.value: {
                            if (this.isUserEmployee) return "수락여부를 선택해주세요.";
                            break;
                        }
                        case EXPO_MATCHING_DIRECTIONS.TO_EMPLOYER.value: {
                            if (this.isUserEmployer) return "수락여부를 선택해주세요.";
                            break;
                        }
                    }

                    return "수락대기 중입니다.";
                }
                case true: {
                    let { isOnline } = this.item?.employer?.interview || {};
                    let type = isOnline ? "온라인" : "오프라인";

                    let time = this.item?.interviewAt?.toDateTime?.();

                    return `${type} 면접일시: ${time}`;
                }
                case false: {
                    return;
                }
            }
        },
        coda() {
            if (this.item.isGranted !== true) return;
            if (!(this.isUserEmployee || this.isUserEmployer)) return;

            let { isOnline, location } = this.item?.employer?.interview || {};
            if (isOnline) return "해당 시각에 온라인면접 버튼을 클릭해주세요.";
            else return `오프라인 면접장소: ${location}`;
        },
    },
};
</script>

<style>
</style>